import React from 'react';
import PropTypes from 'prop-types';
import { StatusBlock } from 'components/status';

// A review's recorded outcome level in the level's own colour, or "-" when the review recorded
// none, so every page showing a recorded outcome presents it alike.
export function OutcomeLevelDisplay(
    {
        outcomeLevel = null
    }
) {
    if (outcomeLevel == null) {
        return (<>-</>);
    }

    return (
        <StatusBlock background={outcomeLevel.colour}>
            {`Level ${outcomeLevel.number} - ${outcomeLevel.name}`}
        </StatusBlock>
    );
}

OutcomeLevelDisplay.propTypes = {
    outcomeLevel: PropTypes.shape({
        number: PropTypes.number,
        name: PropTypes.string,
        colour: PropTypes.string
    })
};
